import React from 'react'
import Thread from './Thread'
import ThreadNumber from './ThreadNumber'
import PlaceThread from './PlaceThread'
import styled from 'react-emotion'
import { discussBlockHighlight } from '../../style'

const HighlightBlock = styled('div')({
  position: 'absolute',
  pointerEvents: 'none',
  ...discussBlockHighlight
})

const Overlay = styled('div')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  cursor: 'default'
})

const Discuss = ({
  threads,
  newThread,
  activeThread,
  highlightBlock,
  positionThread
}) => (
  <>
    {/* Placement Overlay */}
    {newThread && !newThread.id && <PlaceThread />}

    {/* Prevent interaction with other things when thread is open */}
    {activeThread && <Overlay />}

    {/* Outline active block */}
    {highlightBlock && <HighlightBlock style={highlightBlock} />}

    {/* Thread Number Icons */}
    {threads.map(thread => (
      <ThreadNumber thread={thread} key={thread.id} />
    ))}

    {/* Active Thread */}
    {activeThread &&
      positionThread(({ ref, style, placement }) => (
        <Thread
          thread={activeThread}
          style={style}
          innerRef={ref}
          placement={placement}
        />
      ))}
  </>
)

export default Discuss
